import React from "react";
import ReactDOM from "react-dom";

//import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/css/all.min.css");
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles/login.css";

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);
